import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { installApiSessionObserver } from "./apiSession";
import "./styles.css";
import "./importedOrders.css";
import "./ordersMinimal.css";
import "./workspaceTables.css";
import "./documentStandard.css";
import "./compactDesktop.css";
import "./shellGeometry.css";

installApiSessionObserver();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
